import { useAuth } from "react-oidc-context";

import { UseRedirectUserToSignInReturnType } from "@/hooks/session/useRedirectUserToSignIn/types";

export const useRedirectUserToSignIn =
  (): UseRedirectUserToSignInReturnType => {
    const { signinRedirect } = useAuth();

    return { redirectUserToSignIn: signinRedirect };
  };
